module.exports = __webpack_public_path__ + "static/media/season_preparation_m@2x.73f0daf0.png";